(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[973],{

/***/ 9586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[id]",
      function () {
        return __webpack_require__(9202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(111);
/* harmony import */ var _components_productItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9070);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(977);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7558);
/* harmony import */ var _components_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1810);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1043);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1358);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_paginate__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6896);
/* harmony import */ var _assets_images_browser_png__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(789);
/* harmony import */ var _assets_images_icons_left_chevron_png__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5751);
/* harmony import */ var _assets_images_icons_right_chevron_png__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8464);



















var Shop = function(query) {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), productList = ref1[0], setProductList = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), productsPage = ref2[0], setProductsPage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        minPrice: (query === null || query === void 0 ? void 0 : query.minPrice) ? query.minPrice : "",
        maxPrice: (query === null || query === void 0 ? void 0 : query.maxPrice) ? query.maxPrice : ""
    }), priceState = ref3[0], setPriceState = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), allCategory = ref4[0], setAllCategory = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), changeCategory = ref5[0], setChangeCategory = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((query === null || query === void 0 ? void 0 : query.changeSize) ? query.changeSize : ""), changeSize = ref6[0], setChangeSize = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), sizeData = ref7[0], setSizeData = ref7[1];
    var locale = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.global.locale;
    });
    var currentPageQuery = router.query.id;
    var queryData = query.item;
    var onchangeRadio = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(evt) {
            var value;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                value = Number(evt.target.value);
                setChangeCategory(evt.target.name = value);
                setChangeSize("");
                router.push("/shop/1?&item=".concat(value).concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                getFilterSizeData(value);
                return [
                    2
                ];
            });
        });
        return function onchangeRadio(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    var getFilterSizeData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(value) {
            var dataValue, filterReq;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataValue = Number(value);
                        return [
                            4,
                            (0,_api_api__WEBPACK_IMPORTED_MODULE_4__/* .getFilterSize_req */ .aZ)([
                                dataValue
                            ])
                        ];
                    case 1:
                        filterReq = _state.sent();
                        setSizeData(filterReq.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getFilterSizeData(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onchangeRadioSize = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(evt) {
            var sizeValue;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                sizeValue = Number(evt.target.value);
                setChangeSize(evt.target.name = sizeValue);
                router.push("/shop/1?item=".concat(query.item, "&changeSize=").concat(sizeValue).concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                filteredData([
                    queryData
                ], sizeValue);
                return [
                    2
                ];
            });
        });
        return function onchangeRadioSize(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getFilterSizeData(query.item);
    }, []);
    var handleChangePrice = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(evt) {
            var value;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                value = evt.target.value;
                if (evt.target.name === "minPrice") {
                    router.push("/shop/1?item=".concat(router.query.item ? router.query.item : changeCategory).concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(value > 0 ? "&minPrice=".concat(value) : "").concat((priceState === null || priceState === void 0 ? void 0 : priceState.maxPrice) > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                }
                if (evt.target.name === "maxPrice") {
                    router.push("/shop/1?item=".concat(router.query.item ? router.query.item : changeCategory).concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(value > 0 ? "&maxPrice=".concat(value) : ""));
                }
                setPriceState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, priceState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, evt.target.name, value)));
                return [
                    2
                ];
            });
        });
        return function handleChangePrice(evt) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCategoryReq = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            var getCategoryReqData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_api_api__WEBPACK_IMPORTED_MODULE_4__/* .categoryGet_req */ .qK)()
                        ];
                    case 1:
                        getCategoryReqData = _state.sent();
                        setAllCategory(getCategoryReqData);
                        return [
                            2
                        ];
                }
            });
        });
        return function getCategoryReq() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getCategoryReq();
    }, [
        locale
    ]);
    var filteredData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(data, first, page) {
            var dataQuery, filterReq;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataQuery = Number(data);
                        return [
                            4,
                            (0,_api_api__WEBPACK_IMPORTED_MODULE_4__/* .filterProducts_req */ .D4)(data ? [
                                dataQuery
                            ] : [], first ? first : undefined, priceState, currentPageQuery ? currentPageQuery : page)
                        ];
                    case 1:
                        filterReq = _state.sent();
                        setProductsPage(filterReq.data);
                        setProductList(filterReq.data.filteredProducts);
                        return [
                            2
                        ];
                }
            });
        });
        return function filteredData(data, first, page) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        filteredData(queryData, changeSize);
    }, [
        query
    ]);
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(data) {
            var ref, index;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                index = data.selected;
                if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.item) {
                    router.push("/shop/".concat(index + 1, "?item=").concat(router.query.item ? router.query.item : changeCategory).concat(changeSize > 0 ? "&changeSize=".concat(changeSize) : "").concat(priceState.minPrice > 0 ? "&minPrice=".concat(priceState.minPrice) : "").concat(priceState.maxPrice > 0 ? "&maxPrice=".concat(priceState.maxPrice) : ""));
                    filteredData(queryData, changeSize, index + 1);
                }
                return [
                    2
                ];
            });
        });
        return function handleClick(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var meta = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var item = router.query.item;
        var metaOjb = {
            5: {
                title: intl.messages.chees_5,
                description: intl.messages.chees_desc5
            },
            6: {
                title: intl.messages.backgamon_6,
                description: intl.messages.backgamon_desc6
            },
            56: {
                title: intl.messages.induvidual_56,
                description: intl.messages.induvidual_desc56
            },
            50: {
                title: intl.messages.chees_author,
                description: intl.messages.chees_author_desc
            },
            51: {
                title: intl.messages.order_chees,
                description: intl.messages.order_chees_desc
            },
            52: {
                title: intl.messages.order_chees,
                description: intl.messages.order_desc
            },
            53: {
                title: intl.messages.table,
                description: intl.messages.table_desc
            },
            58: {
                title: intl.messages.shelve,
                description: intl.messages.shelve_desc
            },
            67: {
                title: intl.messages.epoxy,
                description: intl.messages.epoxy_desc
            },
            48: {
                title: intl.messages.author_backgamon,
                description: intl.messages.author_backgamon_desc
            },
            49: {
                title: intl.messages.table_backgamon,
                description: intl.messages.table_backgamon_desc
            },
            78: {
                title: "Պատվիրել Էպօքսիդե Նարդի | Handle Brand",
                description: "Պատվիրեք ընկուզենու փայտից և էպօքսիդային լուծույթից պատրաստված նարդիները Handle-ից | Գնեք օնլայն կամ զանգահարեք +374 33 58 58 50"
            },
            55: {
                title: "Գնել Անհատական Շախմատ | Handle Brand",
                description: "Գնեք հաճարենու փայտից պատրաստված անհատական շախմատները Handle-ից | Անվանական նվերների համար զանգահարեք  033 58 58 50"
            },
            56: {
                title: "Պատվիրել Անհատական Նարդի | Handle Brand",
                description: "Գնեք հաճարենու փայտից պատրաստված անհատական նարդի Handle-ից | Պատվերների համար Բուզանդի 1/3 կամ զանգահարեք  033 58 58 50"
            },
            4: {
                title: "Փայտե Ժամացույցների Մեծ Տեսականի | Handle Brand",
                description: "Ցանկանում ես գնել փայտե ժամացույց <<Հենդլ>> բրենդը ներկայացնում է պատի փայտե ժամացույցների լայն տեսականի | Պատվիրել հիմա"
            },
            3: {
                title: "Հուշանվերների Լայն Տեսականի | Handle Brand",
                description: "Գնել փայտե հուշանվեր | Handle ի մեծ տեսականին կզարմացնի Ձեզ | Փորագրված ձեռնափայտեր ցանկացած ճաշակի համար | Ավելին այստեղ"
            },
            2: {
                title: "Շախմատի և Նարդու Խաղաքարեր | Handle Brand",
                description: "Գնեք նարդու և շախմատի խաղաքարեր ցանկացած դիզայնով | Շախմատի խաղաքարերի մեծ տեսկանի Handle.am - ում | Գնել հիմա"
            },
            1: {
                title: "Գինու և Կոնյակի Տակառների Մեծ Տեսականի | Handle Brand",
                description: "Գնել կոնյակի և գինու տակառ Handle - ից | Կոնյակի տակառներ, գինու տակառներ, դուբի տակառներ խմիչքների համար | Տեսեք ավելին այստեղ"
            }
        };
        return metaOjb[item];
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        meta: meta,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "shop",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    title: "".concat((query === null || query === void 0 ? void 0 : query.discount) === "discount" ? intl.messages.discount : intl.messages.shop),
                    currentPage: "".concat((query === null || query === void 0 ? void 0 : query.discount) === "discount" ? intl.messages.discount : intl.messages.shop)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "filter-section flex flex-ai-center flex-jc-between",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "filter-left flex flex-ai-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_select__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        label: intl.messages.category,
                                        handleChange: onchangeRadio,
                                        name: "changeCategory",
                                        value: queryData ? queryData : changeCategory,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: allCategory === null || allCategory === void 0 ? void 0 : (ref = allCategory.data) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: item.categoryId,
                                                    selected: changeCategory ? changeCategory === item.categoryId : queryData === item.id,
                                                    children: item.name
                                                });
                                            })
                                        })
                                    }),
                                    (sizeData === null || sizeData === void 0 ? void 0 : sizeData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "filter-category",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_select__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            label: intl.messages.size,
                                            handleChange: onchangeRadioSize,
                                            name: intl.messages.size,
                                            value: changeSize,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: intl.messages.selectOne
                                                    }),
                                                    sizeData === null || sizeData === void 0 ? void 0 : sizeData.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: item.id,
                                                            selected: item.id,
                                                            children: item.name
                                                        });
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "field-item price-range",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: intl.messages.priceRange
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "number",
                                                        placeholder: intl.messages.from,
                                                        onChange: handleChangePrice,
                                                        value: priceState.minPrice,
                                                        name: "minPrice"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "number",
                                                        placeholder: intl.messages.to,
                                                        onChange: handleChangePrice,
                                                        value: priceState.maxPrice,
                                                        name: "maxPrice"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-wrap",
                            children: productList.length > 0 ? productList === null || productList === void 0 ? void 0 : productList.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_productItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    image: item.image,
                                    name: item.title,
                                    size: item.size,
                                    price: item.price,
                                    code: item.code,
                                    categoryName: item.categoryName,
                                    tag: item.discount,
                                    oldPriceData: true,
                                    id: item.id,
                                    currency: item.currency,
                                    changeSize: changeSize,
                                    minPrice: priceState.minPrice,
                                    maxPrice: priceState.maxPrice
                                });
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "product-not-found",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _assets_images_browser_png__WEBPACK_IMPORTED_MODULE_10__/* ["default"].src */ .Z.src,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        children: intl.messages.productNotFound
                                    })
                                ]
                            })
                        }),
                        (productsPage === null || productsPage === void 0 ? void 0 : productsPage.pagesCount) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_paginate__WEBPACK_IMPORTED_MODULE_8___default()), {
                            previousLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _assets_images_icons_left_chevron_png__WEBPACK_IMPORTED_MODULE_11__/* ["default"].src */ .Z.src,
                                alt: ""
                            }),
                            nextLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _assets_images_icons_right_chevron_png__WEBPACK_IMPORTED_MODULE_12__/* ["default"].src */ .Z.src,
                                alt: ""
                            }),
                            breakLabel: "...",
                            pageCount: productsPage === null || productsPage === void 0 ? void 0 : productsPage.pagesCount,
                            marginPagesDisplayed: 1,
                            pageRangeDisplayed: 3,
                            onPageChange: function(data) {
                                return handleClick(data);
                            },
                            containerClassName: "pagination justify-content-center",
                            pageClassName: "page-item",
                            pageLinkClassName: "page-link",
                            previousClassName: "page-item",
                            previousLinkClassName: "page-link",
                            nextClassName: "page-item",
                            nextLinkClassName: "page-link",
                            breakClassName: "page-item",
                            breakLinkClassName: "page-link",
                            activeClassName: "active",
                            forcePage: currentPageQuery - 1
                        })
                    ]
                })
            ]
        })
    });
};
Shop.getInitialProps = function(param) {
    var query = param.query;
    return query;
};
/* harmony default export */ __webpack_exports__["default"] = (Shop);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,940,774,888,179], function() { return __webpack_exec__(9586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);